export const SCROLL_DEPTH_MILESTONES = [25, 50, 75, 100] as const;

export type ScrollDepthMilestone = (typeof SCROLL_DEPTH_MILESTONES)[number];

/**
 * Given the current scroll progress (0–100) and the milestones already fired,
 * return the milestones now reached that still need to fire.
 */
export const getNewScrollMilestones = (
  percent: number,
  fired: ReadonlySet<number>,
  milestones: readonly number[] = SCROLL_DEPTH_MILESTONES,
): number[] => milestones.filter(m => percent >= m && !fired.has(m));
